export default __webpack_public_path__ + "static/1269-a26b4cfdf0c7c698caf5ec5bc90c920d.gif";